module.exports = "/images/Montenegro.png?ea4829899352f34732c4e9bb1f621fb8";